module.exports = __webpack_public_path__ + "img/logo-vertical.1a8ae84b.png";